export enum Alignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
